import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import { Table, EditDeleteCell, InputCell, SelectCell, NewRowTemplate } from "../../components/BasicComponents";

function StudentTable({ students, teachers, grades, genders, onModify, onDelete, onAdd }) {
    return (
        <>
        <Table headers={["Nom", "Genre", "Classe", "Enseignant", ""]}>
            {students.map((data) => (
                <StudentRow
                    key={data.id}
                    id={data.id}
                    name={data.name}
                    gradeId={data.grade_id}
                    genderId={data.gender_id}
                    teacherId={data.teacher_id}
                    teachers={teachers}
                    grades={grades}
                    genders={genders}
                    onModify={onModify}
                    onDelete={onDelete}
                />
            ))}
            <NewRow grades={grades} genders={genders} onAdd={onAdd} />

        </Table>
        </>
    )
}

function StudentRow({ id, name, gradeId, genderId, teacherId, teachers, grades, genders, onModify, onDelete }) {    
    let app = useApp();

    let [change, setChange] = useState(false);
    let [name0, setName0] = useState(name);
    let [grade0, setGrade0] = useState(gradeId);
    let [gender0, setGender0] = useState(genderId);
    let [teacher0, setTeacher0] = useState(teacherId);

    function submitChange() {
        if(app.emptyCheck(name0)) {
            return alert("Le nom est vide");
        }

        onModify(id, name0, grade0, gender0, teacher0);
        setChange(false);
    }
    return (
        <tr key={id}>
            <InputCell value={name0} onChange={e => { setName0(e.target.value); setChange(true); }} placeholder="Nom de l'élève" />
            <SelectCell
                value={gender0 || ""}
                onChange={e => { setGender0(e.target.value); setChange(true); }}
                options={genders.map(data => ({id: data.id, label: data.display_name}))}
                placeholder="- Choisir un genre -" />
            <SelectCell
                value={grade0 || ""}
                onChange={e => { setGrade0(e.target.value); setChange(true); }}
                options={grades.map(data => ({id: data.id, label: data.display_name}))}
                placeholder="- Choisir un niveau -" />
            <SelectCell
                value={teacher0 || ""}
                onChange={e => { setTeacher0(e.target.value); setChange(true); }}
                options={teachers.map(data => ({id: data.id, label: data.display_name}))}
                placeholder="- Aucun enseignant -" />
            <EditDeleteCell onEdit={submitChange} onDelete={() => onDelete(id)} change={change} />
        </tr>
    )
}

function NewRow({ grades, genders, onAdd }) {
    let [newName, setNewName] = useState("");
    let [newGender, setNewGender] = useState("");
    let [newGrade, setNewGrade] = useState("");

    function add() {
        onAdd(newName, newGrade, newGender);
        setNewName("");
        setNewGender("");
        setNewGrade("");
    }

    return (
        <NewRowTemplate>
            <InputCell value={newName} onChange={(e) => { setNewName(e.target.value) }} placeholder="Nom" />
            <SelectCell
                value={newGender || ""}
                onChange={(e) => { setNewGender(e.target.value) }}
                options={genders.map(data => ({id: data.id, label: data.display_name}))}
                placeholder="- Choisir un genre -" />
            <SelectCell
                value={newGrade || ""}
                onChange={(e) => { setNewGrade(e.target.value) }}
                options={grades.map(data => ({id: data.id, label: data.display_name}))}
                placeholder="- Choisir un niveau -" />
            <td></td>
            <td>
                <button onClick={add}>Ajouter</button>
            </td>
        </NewRowTemplate>
    )
}

function Students() {
    let app = useApp();

    let [students, setStudents] = useState([]);
    let [teachers, setTeachers] = useState([]);
    let [grades, setGrades] = useState([]);
    let [genders, setGenders] = useState([]);

    useEffect(() => {
        app.sendGet("/student/list", (data) => {      
            data.map(data => {
                return data.selected = true;
            });

            setStudents(data);
        });

        app.sendGet("/user/list", data => {
            setTeachers(data);
        });

        app.sendGet("/student/grades", data => {
            setGrades(data);            
        });

        app.sendGet("/student/genders", data => {
            setGenders(data);            
        });
    }, []);

    function onModify(id, name, gradeId, genderId, teacherId) {
        
        app.sendPost("/student/update", {id: id, name: name, grade_id: gradeId, gender_id: genderId}, data => {
            setStudents(students.map(data => data.id == id ? {...data, name: name, grade_id: gradeId, gender_id: genderId}:data));
        });

        if(teacherId !== undefined && teacherId !== null) {
            app.sendPost("/student/assign", {id: id, teacher_id: teacherId}, data => {
                setStudents(students.map(data => data.id == id ? {...data, teacher_id: teacherId}:data));
            });
        }
    }

    function onDelete(id) {
        app.sendPost("/student/delete", {id: id}, data => {            
            setStudents(students.filter(data => data.id !== id));

        });
    }

    function onAdd(name, gradeId, genderId) {
        if(app.emptyCheck(name)) {
            return alert("Le nom est vide");
        }

        if(app.emptyCheck(genderId)) {
            return alert("Le genre est vide");
        }
        
        if(app.emptyCheck(gradeId)) {
            return alert("Le niveau est vide");
        }

        app.sendPost("/student/register", {name: name, gender_id: genderId, grade_id: gradeId}, data => {
            setStudents([... students, data]);
        });
    }

    return (
        <>
        <div>
            <h1>Les éleves</h1>
            <StudentTable students={students} teachers={teachers} grades={grades} genders={genders} onModify={onModify} onDelete={onDelete} onAdd={onAdd} />
        </div>
        </>
    )
}

export default Students;